module.exports = __webpack_public_path__ + "static/media/end_khaosat_binhchon.16852e73.png";